import { render, staticRenderFns } from "./Device.version.1.vue?vue&type=template&id=51bb4810&scoped=true&"
import script from "./Device.version.1.vue?vue&type=script&lang=js&"
export * from "./Device.version.1.vue?vue&type=script&lang=js&"
import style0 from "./Device.version.1.vue?vue&type=style&index=0&id=51bb4810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb4810",
  null
  
)

export default component.exports